export namespace IDwellTime {
  export enum Type {
    BRAND = 'BRAND',
    PRODUCT = 'PRODUCT',
    FLASH_SALE = 'FLASH_SALE',
    BRAND_VIDEO = 'BRAND_VIDEO',
  }

  /**
   * Return an instance of IDwellTime with the provided fields. Any field not
   * listed will be populated with an empty value (an empty array,
   * or undefined, whichever is valid for the type of the value.)
   */
  export const build = (partial?: Partial<IDwellTime>): IDwellTime =>
    ({
      ...(partial ?? {}),
    }) as IDwellTime;
}

/**
 * TODO(Sean Benoit): Move this to inalytics_service.proto once /api/dwell-time is out of backend
 * Dwell time denotes the time which a user spends viewing a product, brand or any other item that has a page
 * after clicking a link on a search results page, category navigation, etc.
 */
export interface IDwellTime {
  token: string | undefined;
  /**
   * If the response where this entity came from has an requestId we *must* pass it back here.
   */
  request_id: string | undefined;
  /**
   * We need a way to tie together multiple dwell time reports and since requestId might not always be available. We
   * need an ID generated by the client. The most important property of this ID is that it *must* be the same across
   * multiple dwell time calls for the same entity visit.
   * For example, if a retailer visits a brand and spends 40 seconds on it we expect two calls to the endpoint
   * one with 15 seconds dwell time and another with 30 seconds dwell time. Both calls should have the exact same
   * dwellId. This ID must be globally unique, for example it could be a UUID.
   */
  dwell_id: string | undefined;
  type: keyof typeof IDwellTime.Type | undefined;
  /**
   * The time that was spent on the page. The API allows specifying any time but we really only want four
   * distinct times
   *   1. After 15 seconds on the brand/product page we should fire a dwell time
   *   2. After 30 seconds
   *   3. After 60 seconds
   *   4. Upon navigating away
   */
  time_seconds: number | undefined;
}
